import { useMemo } from 'react';
import { useFormState } from '@carboledger/ui';
import { ShipmentQuantityField as SharedShipmentQuantityField } from '@/components/common';
import { useTranslations } from '@/hooks';
import { buildShipmentQuantityRules } from '../outgoingShipmentsValidation';

/**
 * Props:
 *   assignedByUnit  already-allocated amounts per unit, the floor the entry can't go under
 */
export const ShipmentQuantityField = ({ assignedByUnit }) => {
  const t = useTranslations();
  const { values } = useFormState();

  // The floor is read in the entered unit, never converted.
  const unit = values.shipmentQuantityUnit;
  const rules = useMemo(
    () => buildShipmentQuantityRules(assignedByUnit?.[unit] ?? null, unit),
    [assignedByUnit, unit],
  );

  return <SharedShipmentQuantityField rules={rules} placeholder={t('FORM_QUANTITY_PLACEHOLDER')} />;
};
